import React, { FC } from 'react';

import { Modal, ModalOverlay, ModalContent } from '@vimeo/bokeh';

import ReviewAsGuestForm from './ReviewAsGuestForm';

interface Props {
  xsrft: string;
  closeModal: () => void;
  onSuccessfulLogin: (response: { signup: boolean }) => void;
  submitCommentAsGuest: (guestName: string, guestEmail?: string) => void;
  isActive: boolean;
  isSubmitLoading?: boolean;
  apiErrorCode?: number | null;
  resetApiErrorCode?: (errorCode: number) => void | undefined;
}

const ReviewAsGuestModal: FC<Props> = ({
  xsrft,
  closeModal,
  onSuccessfulLogin,
  submitCommentAsGuest,
  isActive,
  isSubmitLoading = false,
  apiErrorCode = null,
  resetApiErrorCode,
}) => {
  return (
    <Modal isOpen={isActive} onClose={closeModal} size="sm">
      <ModalOverlay />
      <ModalContent maxW="418px">
        <ReviewAsGuestForm
          closeModal={closeModal}
          xsrft={xsrft}
          onSuccessfulLogin={onSuccessfulLogin}
          submitCommentAsGuest={submitCommentAsGuest}
          isSubmitLoading={isSubmitLoading}
          apiErrorCode={apiErrorCode}
          resetApiErrorCode={resetApiErrorCode}
        />
      </ModalContent>
    </Modal>
  );
};

export default ReviewAsGuestModal;
